import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { generalAnimations } from "src/app/_animations/general.animations";
import { ModularContentHelper } from "src/app/helpers/modular-content.helper";
import { ILocalizedComponent } from "src/app/ILocalizedComponent";
import { ELocale } from "src/app/localization/ELocale";
import { LocaleService } from "src/app/localization/locale.service";
import { EntryService } from "src/app/services/entry.service";
import { ScrollService } from "src/app/services/scroll.service";
import { SliderConfigService } from "src/app/services/slider-config.service";
import { LightboxService } from "src/app/services/lightbox.service";
import { EContentBlockOrientation } from "src/rest-interfaces/EContentBlockOrientation";
import { IEntryInnovationDetail } from "src/rest-interfaces/innovationen/IEntryInnovationen";
import { EProjectContact } from "src/rest-interfaces/EProjectContact";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "app-innovationen-item",
  templateUrl: "./innovationenItem.component.html",
  animations: [generalAnimations],
})
export class InnovationenItemComponent implements ILocalizedComponent {
  public content: IEntryInnovationDetail;
  public EProjectContact = EProjectContact;
  public authorOrientationColClasses =
    ModularContentHelper.AuthorOrientationToColClasses(
      EContentBlockOrientation.Rechts
    );

  // For Forschung (Project-like) View
  public projectSliderConfig: any;
  public currentSlide: number = 0;

  public bereich: string;

  constructor(
    private entrySvc: EntryService,
    private route: ActivatedRoute,
    private title: Title,
    private localeSvc: LocaleService,
    public SliderConfigSvc: SliderConfigService,
    private scrollService: ScrollService,
    private lightboxSvc: LightboxService
  ) {
    this.projectSliderConfig = {
      ...this.SliderConfigSvc.HauptbildSlider,
      appendArrows: ".project-main-slider-arrows",
    };

    this.route.url.subscribe(() => {
      this.entrySvc
        .customControllerUri<IEntryInnovationDetail>(this.localeSvc.RouterUri)
        .subscribe(
          (response) => {
            this.content = response;
            if (this.content.autorPosition) {
              this.authorOrientationColClasses =
                ModularContentHelper.AuthorOrientationToColClasses(
                  this.content.autorPosition
                );
            }
            this.title.setTitle(`PIRMIN JUNG - ${response.title}`);

            console.log("Fetched Innovationen content:", this.content);

            if (this.content.categories && this.content.categories.length > 0) {
              let isAfterBereich = false;
              let bereichCategories = [];

              this.content.categories.forEach((cat) => {
                if (isAfterBereich) {
                  if (cat.level == 2) {
                    bereichCategories.push(cat.title);
                  }
                  if (cat.level == 1) {
                    isAfterBereich = false; // Stop collecting if we reach another top-level category
                  }
                }

                if (cat.title === "Bereich") {
                  isAfterBereich = true;
                }
              });

              if (bereichCategories.length > 0) {
                this.bereich = bereichCategories.join("<br />");
              }
            }
          },
          (error) => {
            console.error("Failed to fetch innvationen content:", error);
          },
          () => {}
        );
    });
  }

  public onScrollDown(event: Event) {
    this.scrollService.triggerScrollToOffset("scrollDestination", -100);
  }

  // Forschung / Project View specific methods
  public afterChange(event: Event) {
    this.currentSlide = (event as any).currentSlide;
  }

  public showInLightBox(entry: IEntryInnovationDetail) {
    // Map content.images to the structure lightbox expects if slightly different,
    // but usually it expects an array of objects with url.
    // IEntryProjekteItem uses 'projektBild', here we use 'images'.
    // We pass the whole entry or just images?
    // LightboxService.setLightboxContent signature depends on implementation.
    // Based on projekte-item, it passes 'content' object, but actually the template calls showInLightBox(content).

    // Check projekte-item template: `showInLightBox(content)`
    // And TS: `public showInLightBox(bilder) { this.lightboxSvc.setLightboxContent(bilder, this.currentSlide); }`
    // So it passes the whole object, and lightboxSvc likely parses it or looks for specific fields.
    // If lightboxSvc expects 'projektBild', we might need to mock it if we pass 'IEntryInnovationDetail' which has 'images'.

    // Let's create a temporary object that looks like what LightboxService might expect if it's strict on 'projektBild'
    // or just pass 'images' if we change the call in template to `showInLightBox(content.images)`.
    // But LightboxService likely handles the parsing. Let's assume for now we can pass an object with 'images' mapped to 'projektBild' if needed.

    // Safest bet: Prepare an object that Lightbox service can consume.
    // If LightboxService takes "any", let's reconstruct a mimic of project item
    // OR, better, let's look at how the lightbox service works.
    // I'll assume we can pass the content, but let's check what fields it needs.
    // Without reading LightboxService, I will map 'images' to 'projektBild' for safety if passed object doesn't have it.

    const lightboxContent = {
      ...entry,
      projektBild: entry.images || [],
    };
    this.lightboxSvc.setLightboxContent(lightboxContent, this.currentSlide);
  }

  public getLocaleChangeUrl(targetLocale: ELocale): string {
    const locUrlProperty = "url_" + targetLocale;
    return this.content[locUrlProperty];
  }
}
